import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  analyticsApiRef,
  configApiRef,
  createApiFactory,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { techRadarApiRef } from '@backstage-community/plugin-tech-radar';
import { ConfigTechRadarApi } from './clients/tech-radar/ConfigTechRadarApi';
import { costInsightsApiRef } from "@backstage-community/plugin-cost-insights";
import { ExampleCostInsightsClient } from "./clients/cost-insights/client";
import { GoogleAnalytics4 } from '@backstage-community/plugin-analytics-module-ga4';

import { githubActionsApiRef } from '@backstage-community/plugin-github-actions';
import { GithubActionsProxyClient, githubActionsProxyDeps } from './clients/github-actions/GithubActionsProxyClient';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: techRadarApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => new ConfigTechRadarApi(configApi),
  }),
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  createApiFactory({
    api: costInsightsApiRef,
    deps: {},
    factory: () => new ExampleCostInsightsClient()
  }),
  ScmAuth.createDefaultApiFactory(),
  createApiFactory({
    api: analyticsApiRef,
    deps: { configApi: configApiRef, identityApi: identityApiRef },
    factory: ({ configApi, identityApi }) => GoogleAnalytics4.fromConfig(configApi, { identityApi }),
  }),
  createApiFactory({
    api: githubActionsApiRef,
    deps: githubActionsProxyDeps,
    factory: ({ discoveryApi, identityApi, fetchApi }) =>
      new GithubActionsProxyClient({ discoveryApi, identityApi, fetchApi }),
  }),
];
